// types/zap-guesser/zaps.ts
import { z } from "zod";
var BaseZapStepSchema = z.object({
  id: z.string(),
  app: z.string(),
  type: z.string(),
  action: z.string()
});
var ZapStepSchema = z.object({
  id: z.string(),
  app: z.string(),
  type: z.string(),
  action: z.string()
});
var ZapStepSchemaOptional = z.object({
  id: z.string(),
  title: z.string(),
  app: z.string(),
  type: z.string(),
  action: z.string(),
  steps: z.lazy(() => ZapStepSchemaOptional.array().optional())
});
var ZdlSchema = z.object({
  id: z.string(),
  app: z.string(),
  type: z.string(),
  action: z.string(),
  zdl_version: z.string(),
  steps: z.array(ZapStepSchema)
});
var ZapSchema = z.object({
  id: z.string(),
  title: z.string(),
  zdl: ZdlSchema
});
var ZapSchemaOptional = ZapSchema.extend({
  title: ZapSchema.shape.title,
  zdl: ZapSchema.shape.zdl.extend({
    steps: z.array(ZapStepSchemaOptional)
  }).passthrough()
});

export {
  BaseZapStepSchema,
  ZapStepSchema,
  ZapStepSchemaOptional,
  ZdlSchema,
  ZapSchema,
  ZapSchemaOptional
};
